import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dictionary from '../../../model/Dictionary';
import FlightsScreenController from '../../../containers/flights/FlightsScreenController';
import './FlightsFormStyles.css';
import ChevronRightIcon from '../../../icons/ChevronRightIcon';

export default class FlightsFormDesktop extends Component {
  static propTypes = {
    location: PropTypes.string,
    adults: PropTypes.number,
    infants: PropTypes.number,
    handleClickOpen: PropTypes.func,
    openCalendar: PropTypes.func,
    date: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
  };

  render () {
    const { location, adults, infants, handleClickOpen, openCalendar, date } = this.props;
    let viewDate = FlightsScreenController.formatDateLongMonthWithDay(date);
    return (
      <div style={{ width: '100%', height: '100%' }}>
        <div className='flights-form-field-wrapper'>
          <label className='text-left'>
            {Dictionary.flights.from} {location}
          </label>
          <div className='flights-form-field' onClick={openCalendar}>
            <label>{viewDate}</label>
            <ChevronRightIcon className='icon-right' />
          </div>
        </div>
        <div className='flights-form-field-wrapper'>
          <label className='text-left'>{Dictionary.flights.passengers}</label>
          <div className='flights-form-field'>
            <label onClick={handleClickOpen}>
              {adults}&nbsp;&nbsp;{Dictionary.flights.adults}&nbsp;&nbsp;&nbsp;&nbsp;
              {infants}&nbsp;&nbsp;{Dictionary.flights.infants}
            </label>
            <ChevronRightIcon className='icon-right' />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/flights/flightsForm/FlightsFormDesktop.js